// app/question/questions.js

(function () {
    'use strict';
    var controllerId = 'stakQuestion';
    var urlAPI = "/api";
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$location', '$q', 'Upload', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', '$timeout', 'datacontext', 'sectionMenu', '_', '$translate', stakQuestion]);

    function stakQuestion($rootScope, $scope, $location, $q, Upload, common, bDialog, $routeParams, $uibModal, $timeout, datacontext, sectionMenu, _, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this, onRouteChangeOff;
        vm.title = 'Domande';
        vm.view = 'list';       //Opzione list or detail
        vm.sectionMenu = sectionMenu.setSection(vm.title);
       
        vm.importDisabled = false;
        vm.objName = 'question'; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.test = {};
        vm.questionTest = {};
        vm.records = [];
        vm.deletedFiles = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;
        vm.salva = true;
        vm.change = 0;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.changed = false;
        vm.questionIdClone = 0;

        vm.valideForm = false;
        //Elenco anteprime
        //vm.list.anteprime = [];
        vm.getListAnteprime = getListAnteprime;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Data Decrescente', 'Data', 'Testuale'];//["testuale", "data"];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };
        vm.getListChoices = getListChoices;
        //mi ricavo la lingua in uso
        vm.currentLanguage = $translate.proposedLanguage() || $translate.use();

        //Filtro
        vm.filter = {};
        vm.filter.testuale = " ";
        vm.fTestuale;

        //Metodi su interfaccia
        vm.doAction = doAction;
        vm.goNext = goNext;
        vm.goPrev = goPrev;

        vm.editChoice = editChoice;
        vm.deleteChoice = deleteChoice;
        vm.titleEditBlur = titleEditBlur;
        vm.titleEditFocus = titleEditFocus;
        vm.setChoiceCorrect = setChoiceCorrect;
        vm.item = {};
        vm.pacchettoId = 0;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.clone = cloneItem;
        vm.import = loadModal;
        vm.form = {};
        vm.confirmRoute = confirmRoute;
        vm.deleteQuestion = deleteQuestion;

        vm.isTest = false;
        
        // ---- ACTIVATE -------
        activate();
        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
							.then(function () {	
							    if ($routeParams.questionId != null) {
							        vm.testId = ($routeParams.testId != null) ? $routeParams.testId : 0;
                                    
							        vm.pacchettoId = ($routeParams.pacchettoId != null) ? $routeParams.pacchettoId : 0;

							        if (vm.pacchettoId != null) {
							            if ($routeParams.readonly != null)
							                vm.item.readonly = $routeParams.readonly == 'true' ? 1 : 0;
							        }
							        
							        if(vm.pacchettoId != 0)							        
							            vm.sectionMenu = sectionMenu.setSection("Pacchetti");
							        else
							            vm.sectionMenu = sectionMenu.setSection("Test");

							        getRecord($routeParams.questionId, false);
							       
							    }
							});
        }

        //****************************************************
        /*CONFIRM SAVE BEFORE CHANGE ROUTE */
        //****************************************************
        function init() {
            //initialize data here..    
            vm.item.editForm = false;

            //Make sure they"re warned if they made a change but didn"t save it
            //Call to $on returns a "deregistration" function that can be called to
            //remove the listener (see routeChange() for an example of using it)
            onRouteChangeOff = $scope.$on("$locationChangeStart", routeChange);
        }
        init();

        function isValidateForm() {
            var nChoices = 0;
            var nChoicesCorrect = 0;
            if (typeof (vm.record.choices) != "undefined") {
                vm.record.choices.forEach(function (item) {
                    if (item.correct) nChoicesCorrect = nChoicesCorrect + 1;
                    nChoices = nChoices + 1;
                });
            }

            if (nChoices < 2 || nChoicesCorrect != 1) {
                return vm.valideForm = false;
            }

            return vm.valideForm = true;
        }

        function validateForm(event) {
            var nChoices = 0;
            var nChoicesCorrect = 0;
            if (typeof (vm.record.choices) != "undefined") {
                vm.record.choices.forEach(function (item) {
                    if (item.correct) nChoicesCorrect = nChoicesCorrect + 1;
                    nChoices = nChoices + 1;
                });
            }

            if (nChoices < 2) {
                //confirm("Attenzione: Bisogna inserire almeno 2 opzioni.");
                bDialog.confirmationDialog($translate.instant('Attenzione'), $translate.instant('InserireDueOpzioni'), "OK").then(function () { });
                //toRemove event.preventDefault();
                return false;
            }

            if (nChoicesCorrect != 1) {
                bDialog.confirmationDialog($translate.instant('Attenzione'), $translate.instant('UnaOpzioneCorretta'), "OK").then(function () { });
                //toRemove event.preventDefault();
                return false;
            }

            return true;
        }

        function confirmRoute(event, newUrl) {
            var attempt = true;
            if (vm.item.editForm) {
                bDialog.confirmationDialog($translate.instant('ModificheNonSalvate'), $translate.instant('ConfermaOk'), $translate.instant('SalvaModificheProcedi'), $translate.instant('AnnullaModificheProcedi')).then(function () { //YES
                    vm.update(modalForm.$event);

                    vm.item.editForm = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    //Cancello il nuovo file dal Server
                    DeleteNewFile(vm.item.imgPath_new);
                    
                    if (vm.testId > 0 && vm.pacchettoId == 0) 
                        $location.url("/STAK_test/" + vm.testId);
                    else if (vm.pacchettoId > 0)
                        $location.url("/STAK_test/" + vm.testId + '/' + vm.pacchettoId);

                    return attempt;
                }, function (btn) { // NO
                    vm.item.editForm = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    //Cancello il nuovo file dal Server
                    DeleteNewFile(vm.item.imgPath_new);

                    if (vm.testId > 0 && vm.pacchettoId == 0)
                        $location.url("/STAK_test/" + vm.testId);
                    else if (vm.pacchettoId > 0)
                        $location.url("/STAK_test/" + vm.testId + '/' + vm.pacchettoId);

                    vm.change = 0;
                    return attempt;
                });
            }
            else {
                attempt = false;
                vm.item.editForm = false;
                onRouteChangeOff();

                //Cancello il nuovo file dal Server
                //DeleteNewFile(vm.item.imgPath_new);
                //console.info('Delete file 2', vm.item.imgPath_new);
                 
                if (vm.testId > 0 && vm.pacchettoId == 0)
                    $location.url("/STAK_test/" + vm.testId);
                else if (vm.pacchettoId > 0)
                    $location.url("/STAK_test/" + vm.testId + '/' + vm.pacchettoId);
            }

            return attempt;
        }

        function routeChange(event, newUrl, oldUrl) {
            vm.change++;
            if (vm.change == 1) {
                if (confirmRoute(event, newUrl)) {
                    event.preventDefault();
                    return;
                }
            }
        }

        function DeleteNewFile(pathFile) {
            return datacontext.stak_question_deleteNewFile(pathFile).then(function (data) {
                return data;
            });
        }

        //****************************************************
        /*CROP IMAGE */
        //****************************************************
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.cropper.cropWidthMax = 400;
        vm.cropper.cropHeightMax = 200;
        vm.bounds = {};
        vm.bounds.left = 1;
        vm.bounds.right = 200;
        vm.bounds.top = 100;
        vm.bounds.bottom = 1;

        //****************************************************
        // METODI 
        //****************************************************
        function getRecord(id, bClone) {
            init();
            if (id == 0) {
                vm.record.Id = 0;

                //getQuestionTest
                if (vm.testId > 0) {
                    //getTest
                    //per attivare la navigazione delle domande del Test
                    datacontext.stak_test_get(vm.testId).then(function (data) {
                        //per attivare la navigazione delle domande del Test
                        vm.records = _.sortBy(data.questions, function (o) { return o.sequence; });
                        vm.countRecords = typeof (data.questions) != "undefined" ? data.questions.length : 0;
                        vm.index = vm.countRecords;

                        if (data.statusCode == 3) {
                            vm.item.readonly = 1;
                        }
                        else
                            vm.item.readonly = 0;

                        if ($rootScope.bAmministratore)
                            vm.item.readonly = 1;

                        return vm.test = data;
                    });
                }
            } else {
                return datacontext.stak_question_get(id).then(function (data) {
                    if (typeof (data) == "undefined" || data == "404")
                        return;

                    vm.record = data;
                    vm.record.image = vm.record.imgPath;
                    vm.record.choices.forEach(function (ch) {
                        ch.image = ch.imgPath;
                    });

                    /*
                   Se bClone == true, leggo il record da clonare e cancello gli Id cosi da poter salvare come nuovo record
                   */
                    if (bClone == true) {
                        vm.item.editForm = true;
                        vm.index = vm.countRecords;
                        vm.record.bNew = false; //La domanda viene definita come nuova
                        vm.record.Id = 0;
                        vm.record.choices.forEach(function (ch) {
                            ch.bNew = false; //L"opzione viene definita come nuova
                            ch.Id = 0;
                        });
                    }

                    //Azzera liste			
                    isValidateForm();

                    //getQuestionTest
                    if (id > 0 && vm.testId > 0) {
                        datacontext.stak_questionTest_getAllByQuestion(vm.testId, id, "").then(function (data) {
                            //Per gestire correttamente la navigazione delle domande del test
                            vm.index = data.sequence - 1;
                            vm.questionTest = data;

                            //getTest
                            //per attivare la navigazione delle domande del Test
                            datacontext.stak_test_get(vm.testId).then(function (data) {
                                //per attivare la navigazione delle domande del Test
                                vm.records = _.sortBy(data.questions, function (o) { return o.sequence; });
                                vm.countRecords = typeof (data.questions) != "undefined" ? data.questions.length : 0;

                                if (data.statusCode == 3) {
                                    vm.item.readonly = 1;
                                }
                                else
                                    vm.item.readonly = 0;

                                if ($rootScope.bAmministratore)
                                    vm.item.readonly = 1;

                                return vm.test = data;
                            });
                        });
                    }
                });
            } 
        }
        
         //List Methods
        function getListAnteprime(id) {
            if (!id) return;
            return datacontext.testAnteprime_getAllByTest(id,0).then(function (data) {
                //return vm.list.anteprime = data;
                return data;
            });
        }

        function goNext() {
            if (((vm.record.Id > 0) && (vm.index + 1 == vm.countRecords)) || (vm.record.Id == 0))
                return;

            doAction('goNext');
        }

        function goPrev() {
            if (((vm.record.Id == 0) && (vm.countRecords + 1 == 1)) || ((vm.record.Id > 0) && (vm.index + 1 == 1)))
                return;

            doAction('goPrev');
        }
        

        function doAction(action) {
            if (vm.item.editForm) {
                bDialog.confirmationDialog($translate.instant('ModificheNonSalvate'), $translate.instant('ConfermaOk'), $translate.instant('SalvaModificheProcedi'), $translate.instant('AnnullaModificheProcedi')).then(function () { //YES
                    vm.update(modalForm.$event);

                    switch (action) {
                        case "goNew":
                            return _goNew();
                        case "goClone":
                            return _goClone();
                        case "goNext":
                            return _goNext();
                        case "goPrev":
                            return _goPrev();
                    }

                }, function (btn) { // NO
                    //event.preventDefault();
                    return;
                });
            }
            else {
                switch (action) {
                    case "goNew":
                        return _goNew();
                    case "goClone":
                        return _goClone();
                    case "goNext":
                        return _goNext();
                    case "goPrev":
                        return _goPrev();
                }
            }
        }

        function _goNew() {
            vm.valideForm = false;
            vm.record = { Id: 0 };
            vm.record.choices = [];
            vm.index = vm.countRecords;
        }

        function _goClone() {
            getRecord(vm.record.Id, true);

            logSuccess($translate.instant('DomandaClonata'));
        }

        function _goNext() {          

            if (vm.index + 1 >= vm.countRecords) return;
            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                //getAllByFilter();
                return; //TODO quando accodo il blocco successivo devo attendere il caricamento e andare al successivo
            }
            if (!vm.records) return;

            vm.index++;

            //Vado al successivo
            if (typeof (vm.test.Id) == "undefined" || vm.test.Id == 0)
                return getRecord(vm.records[vm.index].Id, false);
            else
                return getRecord(vm.records[vm.index].questionId, false);
        }

        function _goPrev() {
            if (vm.index <= 0) return;
            if (vm.index - 1 >= vm.records.length && vm.index - 1 < vm.countRecords) {
                return; //TODO quando accodo il blocco successivo devo attendere il caricamento e andare al precedente
            }
            if (!vm.records) return;

            vm.index--;
            if (typeof (vm.test.Id) == "undefined" || vm.test.Id == 0)
                return getRecord(vm.records[vm.index].Id, false);
            else
                return getRecord(vm.records[vm.index].questionId, false);
        }

        function titleEditBlur() {
            vm.titleEdit = false;
            //if (vm.titleEdited == true)
            //    vm.item.editForm = true;
        }

        function titleEditFocus(bFocus) {
            if (vm.item.readonly)
                return;
            if (bFocus == true) {
                vm.titleEdit = true;
                //$("#title").focus();
            } else {
                if (!$("#title").is(":focus"))
                    vm.titleEdit = false;
            }
        }

        function setChoiceCorrect(index, item) {
            if (vm.item.readonly == 1)
                return;
            if (!item.correct) {
                var i = 0;
                vm.record.choices.forEach(function (ch) {
                    if (index == i) {
                        ch.correct = true;
                    } else {
                        ch.correct = false;
                    }
                    i = i + 1;
                });
                vm.item.editForm = true;
            }
        }

        function addRecord(id, clone) {
            return datacontext.stak_question_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
                vm.record = data;
                vm.record.image = vm.record.imgPath;

                if (typeof (clone) != "undefined") {
                    vm.record.Id = 0;
                    vm.record.choices.forEach(function (ch) {
                        ch.Id = 0;
                    });
                } else {
                    vm.index = vm.countRecords - 1;
                    if (vm.testId >= 0)
                        vm.record.questionId = vm.record.Id;

                    vm.record.choices.forEach(function (ch) {
                        ch.image = ch.imgPath;
                    });
                }

            });
        }

        function updateItem(event, clone) {
            if (!validateForm(event))
                return false;

            vm.loading = true;
            vm.salva = false;
            if (vm.record.Id > 0) { //Modifico il record
                if (vm.record.title == null || vm.record.title == "") {
                    vm.record.title = vm.record.text;
                    if (vm.record.title == null || vm.record.title == "")
                        vm.record.title = "[" + vm.record.imgName + "]";
                }

                return datacontext.stak_question_update(vm.record).then(function (data) {
                    vm.loading = false;
                    vm.salva = true;

                    if (data == "400" || data == "401") { logError($translate.instant('ImpossibileSalvareDati')); return null; }
                    if (vm.records[vm.index] && vm.records[vm.index].questionId)
                        vm.record.questionId = vm.records[vm.index].questionId;
                    vm.records[vm.index] = vm.record;
                    vm.item.editForm = false;

                    if (typeof (clone) != "undefined") {
                        vm.record.Id = 0;
                        vm.record.choices.forEach(function (ch) {
                            ch.Id = 0;
                        });
                    }

                    //vm.bClone = false;
                    logSuccess($translate.instant('DatoSalvato'));
                    vm.record = data;
                    vm.record.image = vm.record.imgPath;
                    vm.record.choices.forEach(function (ch) {
                        ch.image = ch.imgPath;
                    });
                    return vm.record;
                });
            } else { //Aggiungo il record
                if (vm.testId >= 0) { //Aggiungo Domanda e la inserisco come ultima nel Test
                    return datacontext.stak_question_addToTest(vm.record, vm.testId).then(function (data) {
                        vm.loading = false;
                        vm.salva = true;

                        if (!data || data == "401") {
                            logError($translate.instant('ImpossibileSalvareDati'));
                            return null;
                        }
                        vm.item.editForm = false;
                        addRecord(data.Id, clone);

                        logSuccess($translate.instant('DatoSalvato'));
                        vm.record = data;
                        vm.record.image = vm.record.imgPath;
                        vm.record.choices.forEach(function (ch) {
                            ch.image = ch.imgPath;
                        });
                        return vm.record;
                    });
                } else { //Aggiungo Domanda
                    return datacontext.stak_question_add(vm.record).then(function (data) {
                        vm.loading = false;
                        vm.salva = true;     

                        if (!data || data == "401") {
                            logError($translate.instant('ImpossibileSalvareDati'));
                            return null;
                        }
                        vm.item.editForm = false;
                        addRecord(data.Id, clone);

                        logSuccess($translate.instant('DatoSalvato'));
                        vm.record = data;
                        vm.record.image = vm.record.imgPath;
                        vm.record.choices.forEach(function (ch) {
                            ch.image = ch.imgPath;
                        });
                        return vm.record;
                    });
                }
            }
        }

        function cloneItem(event) {
            confirmRoute(event, "", "clone_question");
        }

        function getListChoices(id) {
            if (!id) return;

            return datacontext.stak_choice_getAllByQuestion(id, "").then(function (data) {
                return vm.record.choices = data;
            });
        }

        function deleteQuestion(item) {
            var title = (item.title != null) ? item.title : item.imgName;
            var msg = " " + $translate.instant('Domanda') + ": " + title;
            bDialog.deleteDialog(msg).then(function () {
                if (vm.record.Id > 0) {
                    return datacontext.stak_question_deleteFromTest(item.Id, vm.testId).then(function (data) {
                        if (data != "204") return logError($translate.instant('ErroreRimozione'));

                        vm.confirmRoute(modalForm.$event, '');
                    });
                } else {
                    vm.item.editForm = false;
                    vm.confirmRoute(modalForm.$event, '');
                }
            });
        }

        function loadModal() {
            //var record = { Id: vm.record.Id, Name: vm.record.Username };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/STAK_Question/modal/domandaLoad.html',
                controller: 'stakDomandaLoad',
                resolve: {
                    testId: function () {
                        return 0;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ImpossibileSalvareDati'));
                cerca();
                logSuccess($translate.instant('DomandeImportate'));
                //getListRuoli(vm.record.Id);
            });
        }

        function deleteChoice(item) {
            var msg = " " + $translate.instant('Opzione') + " " + item.text;
            bDialog.deleteDialog(msg).then(function () {
                if (item.Id > 0) {
                    return datacontext.stak_choice_delete(item.Id).then(function (data) {
                        if (data != "204" && data != "400") return logError($translate.instant('ErroreRimozione'));

                        logSuccess($translate.instant('DatoSalvato'));
                        var index = vm.record.choices.indexOf(item);
                        vm.record.choices.splice(index, 1);
                    });
                } else {
                    var index = vm.record.choices.indexOf(item);
                    vm.record.choices.splice(index, 1);
                }

            });
        }


        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            //vm.get(returnItem.Id, vm.countRecords - 1);
            _goNew();
        }

        function editChoice(item, dataType, indexChoice) {
            if (vm.item.readonly)               
                return;                

            //var record = { Id: vm.record.Id, Name: vm.record.text }
            if (item == "404") item = null;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/STAK_Question/modal/ChoiceAdd.html",
                controller: "stakChoiceAdd",
                windowClass: "editChoice",
                resolve: {
                    question: function () {
                        return vm.record;   //Carica Array con la sola Domanda visualizzata 
                    },
                    choice: function () {
                        return item;    //QuestionId impostata con record visualizzato
                    },
                    testId: function () {
                        return vm.testId;    //testId oppure 0 se non � agganciato al test
                    },
                    dataType: function () {
                        return dataType;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                vm.item.imgPath_new = returnItem.imgPath;
                if (dataType == "Q") {		//QUESTION
                    /*
					if (vm.record.imgPath != null && vm.record.imgPath != returnItem.imgPath)
						vm.deletedFiles.push(vm.record.imgPath);
					*/
                    returnItem.title = vm.record.title;
                    vm.record = returnItem;
                    vm.record.bNew = false;
                    /*if (vm.record.Id == 0)
					{*/
                    if (vm.record.title == null || vm.record.title == "") {
                        vm.record.title = vm.record.text;
                        if (vm.record.title == null || vm.record.title == "")
                            vm.record.title = "[" + vm.record.imgName + "]";
                    }
                    //}

                } else {								//CHOICES
                    //imposto la choice i-esima come restituita dalla popup
                    if (typeof (vm.record.choices) == "undefined")
                        vm.record.choices = [];
                    while (vm.record.choices.length <= indexChoice)
                        vm.record.choices.push(null);
                    /*
					if (vm.record.choices[indexChoice].imgPath != null &&vm.record.choices[indexChoice].imgPath != null && vm.record.choices[indexChoice].imgPath != returnItem.imgPath)
						vm.deletedFiles.push(vm.record.choices[indexChoice].imgPath);
					*/
                    vm.record.choices[indexChoice] = returnItem;
                    vm.record.choices[indexChoice].bNew = false;
                    //se la choice modificata ha la spunta "Corretta" imposto le altre come sbagliate
                    if (returnItem.correct) {
                        var index = 0;
                        if (typeof (vm.record.choices) != "undefined") {
                            vm.record.choices.forEach(function (item) {
                                if (index != indexChoice)
                                    vm.record.choices[index].correct = false;
                                index = index + 1;
                            });
                        }
                    }
                }

                //logSuccess("Record salvato con successo");
                vm.item.editForm = true;
                isValidateForm();
            });
        }
    }
})();
